export default __webpack_public_path__ + "static/media/reperence3.2746f017.jpg";